import { makeApiRequest } from 'actions/api';
import RequestService from 'services/RequestService';

export const CLOSE_CUSTOMER_REPORT = 'CLOSE_CUSTOMER_REPORT';
export const CLOSE_CUSTOMER_REPORT_REQUEST = 'CLOSE_CUSTOMER_REPORT_REQUEST';
export const CLOSE_CUSTOMER_REPORT_RESPONSE = 'CLOSE_CUSTOMER_REPORT_RESPONSE';
export const CLOSE_CUSTOMER_REPORT_ERROR = 'CLOSE_CUSTOMER_REPORT_ERROR';

export const CREATE_CUSTOMER_REPORT = 'CREATE_CUSTOMER_REPORT';
export const CREATE_CUSTOMER_REPORT_REQUEST = 'CREATE_CUSTOMER_REPORT_REQUEST';
export const CREATE_CUSTOMER_REPORT_RESPONSE = 'CREATE_CUSTOMER_REPORT_RESPONSE';
export const CREATE_CUSTOMER_REPORT_ERROR = 'CREATE_CUSTOMER_REPORT_ERROR';

export const GET_CUSTOMER_REPORT = 'GET_CUSTOMER_REPORT';
export const GET_CUSTOMER_REPORT_REQUEST = 'GET_CUSTOMER_REPORT_REQUEST';
export const GET_CUSTOMER_REPORT_RESPONSE = 'GET_CUSTOMER_REPORT_RESPONSE';
export const GET_CUSTOMER_REPORT_ERROR = 'GET_CUSTOMER_REPORT_ERROR';

export const GET_CUSTOMER_REPORT_ACTION = 'GET_CUSTOMER_REPORT_ACTION';
export const GET_CUSTOMER_REPORT_ACTION_REQUEST = 'GET_CUSTOMER_REPORT_ACTION_REQUEST';
export const GET_CUSTOMER_REPORT_ACTION_RESPONSE = 'GET_CUSTOMER_REPORT_ACTION_RESPONSE';
export const GET_CUSTOMER_REPORT_ACTION_ERROR = 'GET_CUSTOMER_REPORT_ACTION_ERROR';

export const SET_CURRENT_STAGE = 'SET_CURRENT_STAGE';
export const SET_CURRENT_STAGE_ATTRIBUTES = 'SET_CURRENT_STAGE_ATTRIBUTES';

export const createCustomerReport = () =>
  makeApiRequest({
    requestType: CREATE_CUSTOMER_REPORT,
    method: RequestService.createCustomerReport,
  });

export const getCustomerReport = (entranceStage = false) =>
  makeApiRequest({
    requestType: GET_CUSTOMER_REPORT,
    method: RequestService.findCustomerReport,
    params: { entranceStage },
  });

export const getCustomerReportAction = params =>
  makeApiRequest({
    requestType: GET_CUSTOMER_REPORT_ACTION,
    method: ({ params }) => RequestService.createCustomerReportAction(params),
    params,
  });

export const closeCustomerReport = params =>
  makeApiRequest({
    requestType: CLOSE_CUSTOMER_REPORT,
    method: ({ params }) => RequestService.closeCustomerReport(params),
    params,
  });
